var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ preview: _vm.$route.name === 'preview' },attrs:{"id":"app"}},[_c('navigation'),_vm._v(" "),_c('logo'),_vm._v(" "),_c('router-view',{key:_vm.$route.path})],1)}
var staticRenderFns = []

export { render, staticRenderFns }